module.exports = __webpack_public_path__ + "img/vip-selected-006-d8f643a3161d4755aa2a9323f6eb8782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/member/equity/vip-selected-006.png
// module id = 523
// module chunks = 0